import { ElementType } from './Section';
import { ContentTheme } from '@jbhi-fi/components/src/Contentful/transformers/ThemeTransformer';

export const overrideElementTheme = (
  elementtype: ElementType,
  elementProps: any,
  contentPalette: ContentTheme['palette']
): any => {
  const { background, text, heading
   } = contentPalette;

  switch (elementtype) {
    case ElementType.contentBanner:
      if ('topBorderColor' in elementProps) {
        return {
          ...elementProps,
          topBorderColor: background,
        };
      }
      return elementProps;

    case ElementType.listingBlock:
      if (elementProps.children && typeof elementProps.children === 'object' ) {
        return {
          ...elementProps,
          children: {
            ...elementProps.children,
            props: {
              ...elementProps.children.props,
              palette: {
                ...elementProps.children.props.palette,
                background,
                text,
              },
            },
          },
           palette: {
            ...elementProps.palette,
            background,
            text,
            heading
          },
        };
      }
      return elementProps;

    case ElementType.productBlock:
      if (elementProps.palette) {
        return {
          ...elementProps,
          palette: {
            ...elementProps.palette,
            background,
            text,
          },
        };
      }
      return elementProps;

    case ElementType.multiColumnBlock:
      if (elementProps.theme) {
        return {
          ...elementProps,
          theme: {
            ...elementProps.theme,
            background,
            text,
          },
        };
      }
      return elementProps;

    default:
      return elementProps;
  }
};
